import { render, staticRenderFns } from "./AltaVentaCartera.vue?vue&type=template&id=42d019ba"
import script from "./AltaVentaCartera.vue?vue&type=script&lang=js"
export * from "./AltaVentaCartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports